const PANMONEY_EXTENDED = 'https://raw.githubusercontent.com/briannichols0702/pancake-default.tokenlist.json/main/pancake-default.tokenlist.json'
const PANMONEY_TOP100 = 'https://raw.githubusercontent.com/briannichols0702/pancake-default.tokenlist.json/main/pancake-default.tokenlist.json'

export const UNSUPPORTED_LIST_URLS: string[] = []

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [
  PANMONEY_TOP100,
  PANMONEY_EXTENDED,
  ...UNSUPPORTED_LIST_URLS,
]

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = []